import styled, { css } from 'styled-components';
import { Typography } from '../../global/theme';
import { mobile_xl } from '../../global/mediaQueryMixin';
import { AlignCenter, FlexCenter } from '../../global/commonStyle';

interface IconDivProps {
  marginLeft?: string;
}

export const BackArrowIcon = styled.div`
  ${FlexCenter}
  opacity: 0;
  visibility: hidden;
`;

export const TaskLinkPreviewMainDiv = styled.div`
  display: flex;
  margin-top: var(--space-12);
  cursor: pointer;
  max-width: fit-content;
`;

export const TaskLinkContainer = styled.div`
  background: var(--background-secondary);
  border-radius: var(--border-radius-6);
  padding: var(--space-8) var(--space-10);
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
  border: 0.5px solid var(--border-primary);
  &:hover {
    ${BackArrowIcon} {
      opacity: 1;
      visibility: visible;
    }
  }
`;

export const TaskLinkContent = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: var(--space-8);
  gap: var(--space-8);
  border-bottom: 0.5px solid var(--border-primary);
`;

export const TaskLinkWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: var(--space-4);
`;

export const TaskProjectName = styled.div`
  color: var(--text-secondary);
  ${Typography.body_md}
`;

export const TaskTitle = styled.span`
  ${AlignCenter}
  gap: var(--space-4);
  color: var(--text-primary);
  ${Typography.body_md_medium}
`;

export const DropDiv = styled.div`
  .active-dropdown {
    background-color: var(--neutral-secondary);
    border-radius: var(--border-radius-6);
  }
  .task-link-embed-dropdown {
    border-radius: var(--border-radius-6);
  }
`;

export const TaskTabSection = styled.div`
  display: flex;
  gap: var(--space-20);

  ${mobile_xl(css`
    gap: var(--space-10);
    flex-wrap: wrap;
  `)}
`;

export const TaskStatus = styled.div`
  ${AlignCenter}
  gap: var(--space-6);
  &.task-assignee {
    img {
      max-width: 18px;
      height: 18px;
      margin-top: var(--space-0);
    }
  }
`;

export const AvatarDiv = styled.div<IconDivProps>`
  ${AlignCenter}
  margin-left: ${({ marginLeft }) => marginLeft || 'var(--space-0)'};
`;
